import "./Header.scss";
import pedra from "../../assets/images/logo-png/pedras8.png";
import logo from "../../assets/images/logo-png/ret2.png";
import fixedLogo from "../../assets/images/logo-png/sodalita8.png";
import capaVideo from "../../assets/videos/capa_v3.mp4";
import MenuSlider from "./MenuSlider";
import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Header: React.FC = () => {
  const location = useLocation();
  const divRef = useRef<HTMLDivElement>(null);
  const [isAtTop, setIsAtTop] = useState(false);
  const isHomePage = location.pathname === "/";

  const handleScroll = () => {
    if (divRef.current) {
      const rect = divRef.current.getBoundingClientRect();
      const isAtTop = rect.bottom <= 120;
      setIsAtTop(isAtTop);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    const video = divRef.current?.querySelector("video");
    if (video) {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          // Se falhar, pode mostrar um botão de play manual aqui
          console.warn("Autoplay falhou");
        });
      }
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const showHeaderContainer = () => {
    return (
      <>
        <div ref={divRef} className="video-container">
          <video src={capaVideo} autoPlay loop muted playsInline preload="auto" />

          <div className="nav-links">
            <nav>
              <a href="#aboutUs">Início</a>
              <a href="#solutions">Soluções</a>
              <a href="/blog">Blog</a>
              <a href="/work-with-us">Trabalhe Conosco</a>
              <a href="/talk">Contato</a>
            </nav>
          </div>

          <div className="content">
            <img
              src={logo}
              alt="Sodalita Bem-Estar Corporativo"
              className={`${isAtTop ? "scrolled" : ""}`}
            />

            <p className="slogan">
              Programas de bem-estar corporativo com atendimento especializado e acompanhamento contínuo dos colaboradores.
            </p>

            <div className="agende">
              <a className="button" href="/talk" id="call-to-action-request-quote">
                Converse com nossa equipe
              </a>
            </div>
          </div>
        </div>
      </>
    );
  };

  const showHeaderFixed = () => {
    return (
      <div className={`headerContainerFixed ${isAtTop || !isHomePage ? "visible" : ""}`}>
        <Link to="/" className="logo" aria-label="Ir para a página inicial">
          <img className="pedras" src={pedra} alt="Sodalita Bem-Estar Corporativo" />
          <img className="fixo" src={fixedLogo} style={{height: "40px"}} alt="Sodalita Bem-Estar Corporativo" />
        </Link>
        {/* <div className="logo">
          
        </div> */}
        <nav>
          <div className="nav-links">
            <a href="/#aboutUs">Início</a>
            <a href="/#solutions">Soluções</a>
            <a href="/blog">Blog</a>
            <a href="/work-with-us">Trabalhe Conosco</a>
            <a href="/talk">Contato</a>
          </div>
        </nav>
      </div>
    );
  };

  return (
    <>
      {isHomePage && showHeaderContainer()}
      {showHeaderFixed()}

      <MenuSlider />
    </>
  );
};

export default Header;
